var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto",attrs:{"color":"white","max-width":"300"},on:{"click":_vm._goDetail}},[_c('v-card-title',[_c('span',{staticClass:"title font-weight-light"},[_vm._v("xxxxx")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }